import { useMemo } from "react"

import { exists } from "shared/lib/exists"
import { getFormattingLocale } from "shared/lib/locale/formattingLocale"

export function useNumberFormat(
  value: string | number,
  options?: Intl.NumberFormatOptions
) {
  return useMemo(() => {
    if (!exists(value)) {
      return null
    }

    let numericValue = NaN

    const formatOptions: Intl.NumberFormatOptions = {
      minimumFractionDigits: 0,
      maximumFractionDigits: 20,
      ...options
    }

    if (typeof value === "number") {
      numericValue = value
    }

    if (typeof value === "string") {
      numericValue = parseFloat(value)
    }

    if (isNaN(numericValue)) {
      return null
    }

    return new Intl.NumberFormat(getFormattingLocale(), formatOptions).format(
      numericValue
    )
  }, [value, options])
}
